import React, { useState } from 'react'

//styles
import "./AuthComponent.css"
import { Tabs, TabsProps } from 'antd';
import AuthLoginForm from './AuthLoginForm';


const AuthComponent = () => {
    const [section, setSection] = useState<string>("1");

const allItems: TabsProps['items'] = [
  {
    key: '1',
    label: 'Iniciar Sesíon',
  },
  {
    key: '2',
    label: 'Crear cuenta',
  },

];

const items =  allItems;

const onChange = (key: string) => {
  setSection(key)
};

  return (
    <div className='authComponent-layout'>
        <div className='authComponent-section'>
            <div className='authComponent-left'>
            </div>
            <div className='authComponent-rigth'>
                <div className='authComponent-header'>
                    <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
                </div>
                <div className='authComponent-body'>
                    <span className='auth-title'> Bienvenido de nuevo</span>
                    <span className='auth-subtitle'>Accede a tu cuenta para ver tus colleccionables favoritos</span>
                    
                    <div className='authLoginForm-componentSection'>
                        {section=="1"? <AuthLoginForm onChange={onChange}></AuthLoginForm> 
                        : section=="2" ? <></>
                        : <></>   }
                    </div>
                </div>

                <div className='authComponentFooter'>
                    <span className='auth-footertext'>Al unirte, aceptas nuestras condiciones de uso y política de privacidad.</span>
                </div>
            </div>
        </div>

    </div>
  )
}

export default AuthComponent